import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import zhHant from 'vuetify/es5/locale/zh-Hant'
import pt from 'vuetify/es5/locale/pt'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  icons: {
    iconfont: 'mdiSvg'
  },
  lang: {
    locales: { zhHant, pt },
    current: 'zhHant'
  },
  theme: {
    themes: {
      light: {
        primary: '#009688',
        secondary: '#e91e63',
        accent: '#607d8b',
        error: '#f44336',
        warning: '#ffeb3b',
        info: '#03a9f4',
        success: '#4caf50'
      }
    }
  }
})

// override Intl.DateTimeFormat for Vuetify date picker
// reference: https://github.com/vuetifyjs/vuetify/blob/master/packages/vuetify/src/components/VDatePicker/VDatePickerDateTable.ts
const IntlDateTimeFormatBackup = Intl.DateTimeFormat
Intl.DateTimeFormat = function (locale, options) {
  // check for this option locale = 'zh', options = { day: 'numeric', timeZone: 'UTC' }
  if (locale && locale.includes('zhHant') &&
    options &&
    options.day && options.day === 'numeric' &&
    options.timeZone && options.timeZone === 'UTC') {
    return new IntlDateTimeFormatBackup('en', options)
  } else {
    let tLocale = locale
    if (locale === 'zhHant') {
      tLocale = 'zh-Hant'
    }
    return new IntlDateTimeFormatBackup(tLocale, options)
  }
}

export default vuetify
